import { makeAutoObservable } from 'mobx';

import { SortDirection } from '@/common/types/sort';
import {
  TYPE_DIAMOND_COLORLESS,
  TYPE_DIAMOND_FANCY,
  TYPE_GEM,
  TYPE_JEWELRY,
  TYPE_LGD_COLORLESS,
  TYPE_LGD_FANCY,
  TYPE_LGD_ROUGH,
  TYPE_ROUGH,
} from '@/product/constants/productTypes';
import { accessGatedFieldRepository } from '@/product/repository/AccessGatedFieldRepository';

export interface SortData {
  id: number;
  title: string;
  field: string;
  direction?: SortDirection;
}

interface ProductTypeSorts {
  sorts: number[];
}

const PRODUCT_SORT_TYPES_MAP: Record<string, string> = {
  [TYPE_DIAMOND_COLORLESS]: TYPE_DIAMOND_COLORLESS,
  [TYPE_DIAMOND_FANCY]: TYPE_DIAMOND_FANCY,
  [TYPE_JEWELRY]: TYPE_JEWELRY,
  [TYPE_LGD_COLORLESS]: TYPE_LGD_COLORLESS,
  [TYPE_LGD_FANCY]: TYPE_LGD_FANCY,
  [TYPE_ROUGH]: TYPE_ROUGH,
  [TYPE_LGD_ROUGH]: TYPE_ROUGH,
  [TYPE_GEM]: TYPE_GEM,
};

class SortRepository {
  sortsByType?: Record<string, SortData[]>;

  constructor() {
    makeAutoObservable(this);
  }

  initSorts(sortsData: SortData[], sortsByProductType: Record<string, ProductTypeSorts>) {
    this.sortsByType = this.mapSortsByProductType(sortsData, sortsByProductType);
  }

  getSortsByProductType(productType: string): SortData[] {
    return this.sortsByType?.[productType]?.filter(accessGatedFieldRepository.isSortAvailable) ?? [];
  }

  private mapSortsByProductType(
    sortsData: SortData[],
    sortsByProductType: Record<string, ProductTypeSorts>,
  ): Record<string, SortData[]> {
    const result: Record<string, SortData[]> = {};

    Object.keys(PRODUCT_SORT_TYPES_MAP).forEach((productType) => {
      result[productType] = sortsByProductType[PRODUCT_SORT_TYPES_MAP[productType]].sorts
        .map((sortId) => sortsData.find((sort) => sort.id === sortId))
        .filter((sort): sort is SortData => Boolean(sort));
    });

    return result;
  }
}

export const sortRepository = new SortRepository();
